import React from 'react'
import { Field } from 'redux-form/immutable'
import ProfileFormAvatarInput from 'app/domains/routes/Profile/General/ProfileFormAvatarInput'

const UserAvatarForm = ({ handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <Field name="avatar" isDashboardCommitDetails component={ProfileFormAvatarInput} />
  </form>
)

export default UserAvatarForm
